// frontend/admin-portal/src/components/procurement/SendPOModal.jsx
import React, { useState } from "react";
import { Modal, Button, Alert } from "@fiberhome/shared-ui";
import {
  openPurchaseOrderPdf,
  buildSupplierMailto,
} from "../../services/purchaseOrderPdfService";
import { useStoreIdentity } from "../../hooks/useStoreIdentity";

export default function SendPOModal({ open, po, supplier, onClose }) {
  const store = useStoreIdentity();
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const supplierEmail = supplier?.email || po?.supplier?.email;

  const handlePdf = () => {
    setError("");
    try {
      openPurchaseOrderPdf({ po, supplier, store });
    } catch (err) {
      setError(err.message || "Could not open PDF");
    }
  };

  const handleEmail = () => {
    setError("");
    if (!supplierEmail) {
      setError("Supplier has no email address on file.");
      return;
    }
    // Open mail client first — this is the most reliable cross-browser way
    // to compose an email. Then prompt the user to download the PDF.
    const url = buildSupplierMailto({ po, supplier, store });
    window.location.href = url;
    setSent(true);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Send PO ${po?.code || ""}`}
      size="md"
      footer={
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
      }
    >
      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}
      {sent && (
        <Alert variant="success" className="mb-3">
          Your mail client should have opened. Don't forget to attach the PDF —
          use the <strong>Download PDF</strong> button first if you haven't.
        </Alert>
      )}

      <div style={{ marginBottom: "0.5rem", fontSize: 13 }}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>
          {supplier?.name || po?.supplier?.name || "Supplier"}
        </div>
        {supplierEmail && (
          <div className="text-muted" style={{ fontSize: 12 }}>
            {supplierEmail}
          </div>
        )}
        {!supplierEmail && (
          <div className="text-muted" style={{ fontSize: 12, marginTop: 4 }}>
            ⚠ No email address on file. You can still download the PDF and send
            it manually.
          </div>
        )}
      </div>

      <div
        style={{
          borderTop: "1px solid var(--fh-border, #eef0f3)",
          paddingTop: "0.75rem",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
        }}
      >
        <Button variant="primary" onClick={handlePdf}>
          📄 Download PDF (opens print dialog)
        </Button>
        <Button
          variant="outline"
          onClick={handleEmail}
          disabled={!supplierEmail}
        >
          ✉️ Open in Email Client
        </Button>
      </div>

      <div
        style={{
          marginTop: "1rem",
          padding: "0.75rem",
          background: "#f8fafc",
          borderRadius: 8,
          fontSize: 11.5,
          color: "#6b7280",
        }}
      >
        <strong>How to send a PO:</strong>
        <ol style={{ margin: "0.4rem 0 0 1rem", padding: 0 }}>
          <li>
            Click <strong>Download PDF</strong> → choose "Save as PDF"
          </li>
          <li>
            Click <strong>Open in Email Client</strong> → attach the PDF
          </li>
          <li>Send</li>
        </ol>
      </div>
    </Modal>
  );
}
